import React, { useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import youtubeIcon from "../../resources/images/youtubeIcon.svg";
import communityIcon from "../../resources/images/communityIcon.svg";
import eventsIcon from "../../resources/images/eventsIcon.svg";
import blogsIcon from "../../resources/images/blogsIcon.svg";
import styles from "./freelearning.module.css";
import { NAV_LINK_CONSTANTS } from "../Header/NavLinksContants";

const FREE_COMMUNITIES = [
    {
        name: "Code with Everyday",
        desc: "Learn with peers and win career accelerators",
        icon: communityIcon,
        link: NAV_LINK_CONSTANTS.PUBLIC_COMMUNITY_URL,
    },
    {
        name: "Youtube",
        desc: "Access our high-quality tutorials and courses, all for free.",
        icon: youtubeIcon,
        link: NAV_LINK_CONSTANTS.PROGRAMMING_PATHSHALA_YOUTUBE_URL,
    },
    {
        name: "Events",
        desc: "Join live & recorded sessions with project-based learning.",
        icon: eventsIcon,
        link: NAV_LINK_CONSTANTS.PUBLIC_EVENTS_URL,
    },
    {
        name: "Blogs",
        desc: "Stay updated with the latest trends and skills in tech.",
        icon: blogsIcon,
        link: NAV_LINK_CONSTANTS.PUBLIC_BLOGS_URL,
    },
];

export default function FreeLearningHoverBox({ isMobileFree = false }) {
    const [open, setOpen] = useState(false);

    const disableScroll = () => {
        document.body.style.overflow = "hidden";
    };

    const enableScroll = () => {
        document.body.style.overflow = "auto";
    };

    const arrowStyle = {
        transition: "transform 0.3s ease",
        transformOrigin: "center",
        transform: open ? "rotate(180deg)" : "rotate(90deg)",
    };

    return (
        <div
            className={styles.resourcesContainer}
            onClick={isMobileFree ? () => setOpen((prev) => !prev) : null}
            onMouseEnter={!isMobileFree ? disableScroll : null}
            onMouseLeave={!isMobileFree ? enableScroll : null}
        >
            <div className={styles.resourcesText}>
                <div className={styles.resourcesDiv}>
                    <div>
                        <div className={styles.resourcesCoursesTitleArrow}>
                            <div className={styles.resourcesHeading}>Free Communities</div>
                            <KeyboardArrowUpIcon
                                className={!isMobileFree ? styles.arrowKeyStyle : null}
                                style={isMobileFree ? arrowStyle : null}
                            />
                        </div>
                        <div className={styles.freeLearningLink}>Interview Preparations</div>
                    </div>
                </div>
            </div>
            <div className={`${styles.hoverBox} ${open ? styles.hoverBoxOpen : ""}`}>
                {FREE_COMMUNITIES.map(({ name, desc, icon, link }) => (
                    <a
                        key={name}
                        className={styles.courseItem}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img src={icon} alt="" className={styles.communityIcon} />
                        <div>
                            <p className={styles.communityName}>{name}</p>
                            <p className={styles.communityDesc}>{desc}</p>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
}
